__turbopack_context__.v({
  "close": "style-module-scss-module__GHkG6a__close",
  "container": "style-module-scss-module__GHkG6a__container",
  "root": "style-module-scss-module__GHkG6a__root",
  "search": "style-module-scss-module__GHkG6a__search",
});
